import React, { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react'
import { commercialisationStatusEnum } from '../../dossier/enums/CommercialisationStatusEnum'
import { OffreModel } from '../../offre/types/OffreModel'
import { TYPE_MODAL_VISITE } from '../enums/typeModalVisite'

export type VisiteConcerneeType = OffreModel & { visiteId?: string, souhaitVisiteParking?: boolean, statutDossier?: commercialisationStatusEnum, idDossier?: string }

interface VisiteConcerneeModel {
	offre: VisiteConcerneeType,
	typeModal: TYPE_MODAL_VISITE
}

export interface VisiteContextProps {
	visiteConcernee: VisiteConcerneeModel | null,
	setVisiteConcernee: Dispatch<SetStateAction<VisiteConcerneeModel | null>>,
}

export const VisiteContext = createContext<VisiteContextProps>({
	visiteConcernee: null,
	setVisiteConcernee: (visiteAModifier) => {
	}
})

interface VisiteProviderProps {
	children: ReactNode
}

export const VisiteProvider: React.FC<VisiteProviderProps> = ({ children }) => {
	const [visiteAModifier, setVisiteAModifier] = useState<VisiteConcerneeModel | null>(null)

	return (
		<VisiteContext.Provider
			value={{
				visiteConcernee: visiteAModifier,
				setVisiteConcernee: setVisiteAModifier
			}}
		>
			{children}
		</VisiteContext.Provider>
	)
}